import React from "react"

type ButtonProps = {
    type?: "button" | "submit" | "reset",
    className?: string,
    onClick?: () => void
}

const AsyncButton: React.FunctionComponent<
    ButtonProps & { disabled?: boolean, loading?: boolean }
> = ({ type, className, onClick, disabled, loading, children }) => (
    <button type={type || "button"} className={className} disabled={disabled || loading} onClick={() => onClick && onClick()}>
        <div className="flex justify-center">
            {loading && <div className="animate-spin mr-2"><i className="fas fa-spinner" /></div>}
            {children}
        </div>
    </button>
)

export default AsyncButton
